import { CaseLabel } from "interfaces/case-label";
import { useLazyFetchV2 } from "hooks/fetch/useLazyFetchV2";

interface LazyFetchResponse {
  count?: number;
  results?: CaseLabel[];
}

interface LazyFetchCaseLabel {
  loading: boolean;
  error: boolean;
  fetchCallback: (url: string) => Promise<LazyFetchResponse>;
}

export const useLazyGetCaseLabels = (): {
  loading: boolean;
  error: boolean;
  fetchCaseLabels: (queryString?: string) => Promise<LazyFetchResponse>;
} => {
  const { loading, error, fetchCallback }: LazyFetchCaseLabel = useLazyFetchV2(
    "GET"
  );

  return {
    loading,
    error,
    fetchCaseLabels: (queryString?: string) =>
      fetchCallback(`case_labels?${queryString ?? ""}`)
  };
};
